// TODO(docusign): Integration entry points for the full DocuSign implementation.
// All three steps run as a Vectr workflow — see docs/VECTR_INTEGRATION.md for the contract.
//   1. createEnvelope    — POST to /api/vectr/docusign/envelopes (Vectr workflow trigger)
//   2. getRecipientView  — Exchange DocuSign recipientView URL, redirect signer to DocuSign web UI
//   3. webhookHandler    — Receive ENVELOPE_COMPLETED callback from DocuSign via Vectr inbound webhook

import React from 'react'
import { Button } from '@/components/ui/Button'
import { Card } from '@/components/ui/Card'
import type { SignatureProvider, SigningSurfaceProps } from '../types'

const DocuSignNotConfigured: React.FC<Pick<SigningSurfaceProps, 'onCancel'>> = ({ onCancel }) => (
  <Card className="p-6">
    <p className="text-sm text-muted-foreground mb-4">
      DocuSign is not configured. Set{' '}
      <code className="font-mono text-xs bg-muted px-1 py-0.5 rounded">
        VITE_DOCUSIGN_INTEGRATION_KEY
      </code>{' '}
      to enable.
    </p>
    <div className="flex justify-end">
      <Button variant="outline" onClick={onCancel}>Cancel</Button>
    </div>
  </Card>
)

export const docusignProvider: SignatureProvider = {
  id: 'docusign',
  displayName: 'DocuSign',
  available() {
    return Boolean(import.meta.env.VITE_DOCUSIGN_INTEGRATION_KEY)
  },
  renderSigningSurface({ onCancel }: SigningSurfaceProps) {
    return <DocuSignNotConfigured onCancel={onCancel} />
  },
}
